import { gql } from '@apollo/client'

import {
  ITEM_WEIGHT_FRAGMENT,
  TOTAL_DELIVERY_PRICE_FRAGMENT
} from '../fragments/delivery-price'

export const ITEM_WEIGHT_QUERY = gql`
  ${ITEM_WEIGHT_FRAGMENT}
  query itemWeight(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: itemWeightFilterInput
  ) {
    itemWeight(
      first: $first
      after: $after
      last: $last
      before: $before
      filter: $filter
    ) {
      edges {
        node {
          ...ItemWeightFragment
        }
        cursor
      }
      totalCount
    }
  }
`

export const TOTAL_DELIVERY_PRICE_QUERY = gql`
  ${TOTAL_DELIVERY_PRICE_FRAGMENT}
  query totalDeliveryPrice(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: TotalDeliveryPriceFilterInput
  ) {
    totalDeliveryPrice(
      first: $first
      after: $after
      last: $last
      before: $before
      filter: $filter
    ) {
      edges {
        node {
          ...TotalDeliveryPriceFragment
        }
        cursor
      }
      totalCount
    }
  }
`
